import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BreadcrumbTitleEnum } from '../../shared/objects/breadcrumb/breadcrumb-title.enum';
import { BreadcrumbType } from '../../shared/objects/breadcrumb/breadcrumb-type';
import { Breadcrumb } from '../../shared/objects/breadcrumb/breadcrumb.model';
import { PageInfo } from '../../shared/objects/breadcrumb/page-info.model';
import { PageUpdate } from '../../shared/objects/breadcrumb/page-update';

@Injectable()
export class BreadcrumbService {
  public idWildcard = 'id';

  private pageInfoSubject = new Subject<PageInfo>();
  public pageInfoSubject$ = this.pageInfoSubject.asObservable();

  private pageChangeSubject = new Subject<PageUpdate>();
  public pageChangeSubject$ = this.pageChangeSubject.asObservable();

  public updatePageInfo(pageInfo: PageInfo) {
    this.pageInfoSubject.next(pageInfo);
  }

  public updatePage(update: PageUpdate) {
    this.pageChangeSubject.next(update);
  }

  public readonly breadcrumbs: Breadcrumb[] = [
    {
      name: 'secure',
      title: '',
      route: 'secure',
      absoluteRoute: 'secure',
      type: BreadcrumbType.Static,
      breadcrumbs: [
        {
          name: 'freight-exchange',
          title: 'SHARED.SECTION-TITLE-FREIGHT-EXCHANGE',
          route: 'freight-exchange',
          absoluteRoute: 'secure/freight-exchange',
          type: BreadcrumbType.Static,
          show: true,
          breadcrumbs: [
            //*Order matters
            {
              name: this.idWildcard,
              title: 'FREIGHT-EXCHANGE-DETAILS.TITLE-BID',
              subTitle: '',
              route: 'freight-exchange',
              absoluteRoute: 'secure/freight-exchange',
              isId: true,
              type: BreadcrumbType.Dynamic,
              show: true,
              showOwnPage: true,
              breadcrumbs: null,
            },
          ],
        },
        {
          name: 'order-list',
          title: 'SHARED.SECTION-TITLE-ORDER-LIST',
          route: 'order-list',
          absoluteRoute: 'secure/order-list',
          type: BreadcrumbType.Static,
          show: true,
          breadcrumbs: [
            //*Order matters
            {
              name: this.idWildcard,
              title: 'ORDER-LIST-DETAILS.TRANSPORT-INFORMATION-ORDER',
              subTitle: '',
              route: 'order-list',
              absoluteRoute: 'secure/order-list',
              isId: true,
              type: BreadcrumbType.Dynamic,
              show: true,
              showOwnPage: true,
              breadcrumbs: [
                {
                  name: 'transport',
                  title: 'SHARED.SECTION-TITLE-TRANSPORT',
                  route: 'transport',
                  shortTitle: 'TI',
                  absoluteRoute: `secure/order-list/${this.idWildcard}/transport`,
                  type: BreadcrumbType.Static,
                  show: true,
                  breadcrumbs: null,
                },
              ],
            },
            {
              name: 'cmr-upload',
              title: 'SHARED.SECTION-TITLE-BATCH-CMR',
              route: 'cmr-upload',
              absoluteRoute: 'secure/order-list/cmr-upload',
              type: BreadcrumbType.Static,
              show: true,
              showOwnPage: true,
              breadcrumbs: null,
            },
          ],
        },
        {
          name: 'incidents',
          title: 'SHARED.SECTION-TITLE-INCIDENT-LIST',
          route: 'incidents',
          absoluteRoute: 'secure/incidents',
          type: BreadcrumbType.Static,
          show: true,
          breadcrumbs: [
            //*Order matters
            {
              name: this.idWildcard,
              title: 'INCIDENTS-DETAILS.TITLE',
              subTitle: '',
              route: 'incidents',
              absoluteRoute: 'secure/incidents',
              isId: true,
              type: BreadcrumbType.Dynamic,
              show: true,
              showOwnPage: true,
              breadcrumbs: null,
            },
          ],
        },
        {
          name: 'self-billing',
          title: 'SHARED.SECTION-TITLE-SELFBILLING',
          route: 'self-billing',
          absoluteRoute: 'secure/self-billing',
          type: BreadcrumbType.Static,
          show: true,
          breadcrumbs: [
            //*Order matters
            {
              name: this.idWildcard,
              title: 'SELF-BILLING-DETAILS.TITLE',
              subTitle: '',
              route: 'self-billing',
              absoluteRoute: 'secure/self-billing',
              isId: true,
              type: BreadcrumbType.Dynamic,
              show: true,
              showOwnPage: true,
              breadcrumbs: null,
            },
          ],
        },
        {
          name: 'tender',
          title: 'SHARED.SECTION-TITLE-TENDERS',
          route: 'tender',
          absoluteRoute: 'secure/tender',
          type: BreadcrumbType.Static,
          show: true,
          breadcrumbs: [
            //*Order matters
            {
              name: this.idWildcard,
              title: 'TENDER-DETAILS.TITLE',
              subTitle: '',
              route: 'tender',
              absoluteRoute: 'secure/tender',
              isId: true,
              type: BreadcrumbType.Dynamic,
              show: true,
              showOwnPage: true,
              breadcrumbs: null,
            },
          ],
        },
        {
          name: 'ex-work-timeslot',
          title: 'SHARED.SECTION-TITLE-EXWORK-LIST',
          route: 'ex-work-timeslot',
          absoluteRoute: 'secure/ex-work-timeslot',
          type: BreadcrumbType.Static,
          show: true,
          breadcrumbs: [
            //*Order matters
            {
              name: this.idWildcard,
              title: 'SHARED.SECTION-TITLE-TRANSPORT',
              subTitle: '',
              route: 'ex-work-timeslot',
              shortTitle: 'TI',
              absoluteRoute: `secure/ex-work-timeslot/${this.idWildcard}`,
              isId: true,
              type: BreadcrumbType.Dynamic,
              show: true,
              showOwnPage: true,
              breadcrumbs: null,
            },
          ],
        },
        {
          name: 'admin',
          title: '',
          route: 'admin',
          absoluteRoute: 'secure/admin',
          type: BreadcrumbType.Static,
          breadcrumbs: [
            {
              name: 'carriers',
              title: 'SHARED.SECTION-TITLE-CARRIERS',
              route: 'carriers',
              absoluteRoute: 'secure/admin/carriers',
              type: BreadcrumbType.Static,
              show: true,
              breadcrumbs: [
                //*Order matters
                {
                  name: this.idWildcard,
                  title: 'CARRIERS.TITLE',
                  subTitle: '',
                  route: 'carriers',
                  absoluteRoute: 'secure/admin/carriers',
                  isId: true,
                  type: BreadcrumbType.Dynamic,
                  show: true,
                  showOwnPage: true,
                  breadcrumbs: null,
                },
              ],
            },
            {
              name: 'approve-carriers',
              title: 'SHARED.SECTION-TITLE-APPROVE-CARRIERS',
              route: 'approve-carriers',
              absoluteRoute: 'secure/admin/approve-carriers',
              type: BreadcrumbType.Static,
              show: true,
              breadcrumbs: [
                //*Order matters
                {
                  name: this.idWildcard,
                  title: 'CARRIERS.TITLE',
                  subTitle: '',
                  route: 'approve-carriers',
                  absoluteRoute: 'secure/admin/approve-carriers',
                  isId: true,
                  type: BreadcrumbType.Dynamic,
                  show: true,
                  showOwnPage: true,
                  breadcrumbs: null,
                },
              ],
            },
            {
              name: 'users',
              title: 'SHARED.SECTION-TITLE-USERS',
              route: 'users',
              absoluteRoute: 'secure/admin/users',
              type: BreadcrumbType.Static,
              show: true,
              breadcrumbs: [
                //*Order matters
                {
                  name: this.idWildcard,
                  title: 'USERS.TITLE',
                  subTitle: '',
                  route: 'users',
                  absoluteRoute: 'secure/admin/users',
                  isId: true,
                  type: BreadcrumbType.Dynamic,
                  show: true,
                  showOwnPage: true,
                  breadcrumbs: null,
                },
              ],
            },
          ],
        },
        {
          name: 'carriers',
          route: 'carriers',
          absoluteRoute: 'secure/carriers',
          type: BreadcrumbType.Static,
          title: '',
          breadcrumbs: [
            //*Order matters
            {
              name: this.idWildcard,
              title: 'CARRIERS.CARRIER-PROFILE',
              subTitle: BreadcrumbTitleEnum.Empty,
              route: 'carriers',
              absoluteRoute: 'secure/carriers',
              isId: true,
              type: BreadcrumbType.Dynamic,
              show: true,
              showOwnPage: true,
              breadcrumbs: null,
            },
          ],
        },
      ],
    },
  ];
}
